import { Link } from "react-router-dom";

const MenuBags = (dropdownRef, closeDropdownMenu) => {
  const links = [
    {
      displayName: "T-Shirt Bags",
      linkTo: "/bags/tshirt",
    },
    {
      displayName: "Brown Paper Bags",
      linkTo: "/bags/paperbag",
    },
    {
      displayName: "Black Trash Bags",
      linkTo: "/bags/trashbag",
    },
  ];

  return (
    <ul ref={dropdownRef}>
      {links.map((link, index) => {
        return (
          <li className="px-4 py-2 hover:bg-containx-beige">
            <Link
              to={link.linkTo}
              onClick={closeDropdownMenu}
              className="block"
              key={"bag-menu-" + index}
            >
              {link.displayName}
            </Link>
          </li>
        );
      })}
      <li className="px-4 py-2 hover:bg-containx-beige font-bold">
        <Link to="/bags" onClick={closeDropdownMenu} className="block">
          See All
        </Link>
      </li>
    </ul>
  );
};

export default MenuBags;
